export default __webpack_public_path__ + "static/media/add.13aafbd7.jpg";